<script setup lang="ts">
import { computed, isVNode } from 'vue'
import { TYPE } from 'vue-toastification'
import AbsIcon from '@/abs-core/shared/components/atoms/AbsIcon.vue'

const props = defineProps<{
  content?: string | any
  type?: TYPE
}>()

const iconConfig = computed(() => {
  switch (props.type) {
    case TYPE.SUCCESS:
      return {
        icon: 'checkmark',
        bgColor: '#81c784',
      }
    case TYPE.ERROR:
      return {
        icon: 'alert-circle',
        bgColor: '#f44336',
      }
    case TYPE.WARNING:
      return {
        icon: 'alert-circle',
        bgColor: '#ff9800',
      }
    case TYPE.INFO:
      return {
        icon: 'information-circle',
        bgColor: '#2196f3',
      }
    default:
      return {
        icon: 'information-circle',
        bgColor: '#757575',
      }
  }
})
</script>

<template>
  <div class="mobile-toast-wrapper">
    <div
      class="icon-container"
      :style="{ backgroundColor: iconConfig.bgColor }"
    >
      <AbsIcon :icon="iconConfig.icon" class="toast-icon" />
    </div>
    <div class="message-container">
      <div class="message">
        <slot>
          <component :is="content" v-if="isVNode(content)" />
          <template v-else>{{ content }}</template>
        </slot>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/_mixins.scss';
@import '@/styles/_constants.scss';

.mobile-toast-wrapper {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.7rem 0 0.7rem 1rem;
  width: 100%;

  .icon-container {
    width: 2.4rem;
    height: 2.4rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .toast-icon {
      width: 1.4rem;
      height: 1.4rem;
      color: white;

      :deep(ion-icon) {
        width: 100%;
        height: 100%;
      }
    }
  }

  .message-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    flex: 1;

    .message {
      font-weight: 600;
      font-size: 1rem;
      color: rgb(var(--color-black));
      line-height: 1.4;
    }
  }
}
</style>
